import { Ano } from './ano';
import { Realizado } from './realizado';

/** Dados de uma classificação nos KPIs de produtividade */
export class Classificacao {
    id: number;
    codigo: number;
    nome: string;
    indicadorCrossSell: number;
    anos: Ano[];
    orcamentos: Realizado;
    orcamentosPerdidos: Realizado;
    pedidos: Realizado;

    constructor(props: Partial<Classificacao>) {
        Object.assign(this, props);
        // Anos
        this.constructorAnos(props?.anos ?? []);
        // Orçamentos
        this.orcamentos = new Realizado(props?.orcamentos ?? null);
        // Orçamentos Perdidos
        this.orcamentosPerdidos = new Realizado(props?.orcamentosPerdidos ?? null);
        // Pedidos
        this.pedidos = new Realizado(props?.pedidos ?? null);
    }

    /** Constructor para os anos */
    private constructorAnos(anos: Ano[]) {
        if (anos && Array.isArray(anos)) {
            this.anos = anos.map(ano => new Ano(ano));
        } else {
            this.anos = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Classificacao {
        return new Classificacao(JSON.parse(json));
    }
}
